export default __webpack_public_path__ + "static/media/delirium.d1efe113.mp3";